<template>
  <HelpChatPanel class="h-screen !rounded-none !shadow-none !border-0" @close="closeWindow" />
</template>

<script setup>
import HelpChatPanel from './HelpChatPanel.vue';

function closeWindow() {
  window.close();
}
</script>
